module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16UbQ7Z/tc-custom/9781646569038.jpg?1723403694363",
      "alt": "This image is the cover for the book Charlie Blackbear"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Charlie Blackbear\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Take an irresponsible, hard-drinking womanizer and dump him into the middle of a logging crew, and it’s a recipe for disaster."), _c('br'), _c('br'), _vm._v("Charlie Blackbear is already a near-legend in his little corner of the world. The size of his package has been the subject of whispers since he was a lad and his sexual conquests the stuff of legends."), _c('br'), _c('br'), _vm._v("When he wakes up drunk in a motel room with a man going down on him, he shrugs it off and goes right back to chasing women. Charlie accepts a job with a logging crew. But when he shares a room at the Boar’s Nest with his best friend, Daniel Warhorse, he fights a growing, unexpected, and unwelcome attraction to his childhood friend. Apparently Daniel feels the same way, and when they finally get together, the world turns on its axis for both of them."), _c('br'), _c('br'), _vm._v("Then handsome, sexy Aden Jones shows up to complicate things. Charlie never suspects the danger lurking at the edge of his complicated life.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Wildyr\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0